import { React } from "react";
import { Loading } from "../../components/common/Loading";
import { Box } from "@mui/material";
import {
	useWalletsQuery,
	useCategoriesQuery,
	// useTransactionsQuery,
} from "../../services/queryHooks";
import { useTranslation } from "react-i18next";

function Dashboard() {
	const { data: wallets, isPending: walletsLoading } = useWalletsQuery();
	const { data: categories, isPending: categoriesLoading } =
		useCategoriesQuery();
	// const { data: transactions, isPending: transactionsLoading } =
	// 	useTransactionsQuery();
	const { t } = useTranslation();

	if (walletsLoading || categoriesLoading) {
		return <Loading loadingText="Loading data for You..." />;
	}
	return (
		<>
			<Box sx={{ mx: 2 }}>
				<h1>{t("wallets")}:</h1>
				{wallets.map((wallet) => (
					<p key={wallet._id}>{wallet.name}</p>
				))}
				<h1>{t("categories")}:</h1>
				{categories.map((category) => (
					<p key={category._id}>
						{category.groupName
							? category.groupName
							: t(category.groupTranslationKey)}
					</p>
				))}
				{/* <h1>{t("transactions")}:</h1>
			{transactions?.map((transaction) => (
				<p key={transaction._id}>{transaction.description}</p>
			))} */}
			</Box>
		</>
	);
}

export default Dashboard;
